export const places = [
  "Desert",
  "Plain",
  "Taiga",
  "Tundra",
  "Wetland",
  "Mountain",
  "river",
  "Cliff",
  "Coast",
  "waterfall",
  "Glacier",
  "valley",
  "grassland",
  "Forest",
  "Rainforest",
  "Woodland",
  "Jungle",
  "ocean",
];
